module.exports = __webpack_public_path__ + "static/logo-4c0559bf85033e879b58935e0e74b9c2.png";